module.exports = __webpack_public_path__ + "static/assets/b246d0b191ec6afb48f0989335ce47d0.png";